type ReportHeroProps = {
  periodLabel: string
}

export function ReportHero({ periodLabel }: ReportHeroProps) {
  return (
    <div className="border border-base-300 bg-base-100 shadow-sm">
      <div className="flex flex-col gap-3 bg-[#050505] px-4 py-4 text-white sm:flex-row sm:items-center sm:justify-between sm:px-6">
        <div>
          <h2 className="text-xl font-extrabold uppercase tracking-wide">
            Inventory Report
          </h2>
          <p className="mt-1 text-xs text-white/75">Item List Summary</p>
        </div>
        <div className="text-left text-xs text-white/95 sm:text-right">
          <p className="font-bold">Report Period</p>
          <p>{periodLabel}</p>
        </div>
      </div>
    </div>
  )
}
